// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__194UM","sendOtp":"AuthorizeToLogin_sendOtp__2H9-Z"};